import { system } from 'styled-system'
import colors from '../constants/colors'
import { colorIndex } from '../constants/colors/colors.types'

export const getColor = (colorIndex: colorIndex) => {
  return colors[colorIndex]
}

export const overrideColorConfig = system({
  color: {
    property: 'color',
    transform: (value) => colors[value],
  },
  backgroundColor: {
    property: 'backgroundColor',
    transform: (value) => colors[value],
  },
  bg: {
    property: 'backgroundColor',
    transform: (value) => colors[value],
  },
  borderColor: {
    property: 'borderColor',
    transform: (value) => colors[value],
  },
  borderTopColor: {
    property: 'borderTopColor',
    transform: (value) => colors[value],
  },
  borderRightColor: {
    property: 'borderRightColor',
    transform: (value) => colors[value],
  },
  borderBottomColor: {
    property: 'borderBottomColor',
    transform: (value) => colors[value],
  },
  borderLeftColor: {
    property: 'borderLeftColor',
    transform: (value) => colors[value],
  },
})

export const numberInputChecking = (string = '1', { min, max }: { min?: number; max?: number }) => {
  const cleansingValue = string.replace(/\D/g, '')
  let parsedValue = parseInt(cleansingValue)
  let formattedValue = new Intl.NumberFormat(['id']).format(parsedValue || 0)
  if (min && parsedValue <= min) {
    parsedValue = min
    formattedValue = new Intl.NumberFormat(['id']).format(min)
  }
  if (max && parsedValue >= max) {
    parsedValue = max
    formattedValue = new Intl.NumberFormat(['id']).format(max)
  }
  return { parsedValue, formattedValue }
}

export const formatTimeDigit = (time: number) => {
  return time <= 9 ? `0${time}` : time
}

export const isImageMimeType = (fileType: string) => {
  const imageTypeRegex = /(^image)(\/)[a-zA-Z0-9_]*/
  if (imageTypeRegex.test(fileType)) return true

  return false
}
